module.exports = __webpack_public_path__ + "src/img/pic.024dfd87.png";